
import { useEffect, useRef } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const MarketSituation = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elementsToObserve = sectionRef.current?.querySelectorAll(".reveal-on-scroll");
    elementsToObserve?.forEach((el) => {
      observer.observe(el);
    });

    return () => {
      elementsToObserve?.forEach((el) => {
        observer.unobserve(el);
      });
    };
  }, []);

  return (
    <section ref={sectionRef} id="market-situation" className="py-20 bg-white dark:bg-gray-900">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center reveal-on-scroll dark:text-gray-50">
          {t('market_situation_title')}
        </h2>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="reveal-on-scroll">
            <div className="rounded-2xl overflow-hidden shadow-subtle-lg">
              <img 
                src="https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80" 
                alt="Energy Market" 
                className="w-full h-auto object-cover aspect-video"
                loading="lazy"
              />
            </div>
          </div>
          
          <div className="space-y-6 reveal-on-scroll">
            <p className="text-gray-700 dark:text-gray-300">
              {t('market_situation_text1')}
            </p>
            <p className="text-gray-700 dark:text-gray-300">
              {t('market_situation_text2')}
            </p>
            <p className="text-gray-700 dark:text-gray-300">
              {t('market_situation_text3')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarketSituation;
